import { useMemo } from 'react';
import { useInstantSearchOwnerFilters } from './useInstantSearchOwnerFilters';
import { DEAL_STATUS_TYPES, joinFilters } from '@/utils/constants';
import { useKanbanContext } from '@/context/kanbanContext';

export const useKanbanFilters = (stageId) => {
	const { isProspect, pipelineId, debtorFilters } = useKanbanContext();
	const isDebtors = pipelineId === process.env.REACT_APP_PIPELINE_DEBTORS;

	// Get all filters
	const { filters, baseFilters } = useInstantSearchOwnerFilters();

	const outstandingDaysSchema = debtorFilters?.outstandingDaysSchema;

	const selectedIsProspect = filters.isProspect || [];
	const selectedCreateDate = filters.createDate || [];
	const selectedEstimatedCloseDate = filters.estimatedCloseDate || [];
	const selectedRenewalDate = filters.renewalDate || [];
	const brokerGroupIds = filters.brokerGroupId || [];

	// // Build filter schema with all filters
	const filterSchema = useMemo(() => {
		if (isProspect) {
			const filtersArray = [
				...baseFilters,
				'isProspect:=true',
				`stage:=\`${stageId}\``,
			];

			if (brokerGroupIds.length > 0) {
				filtersArray.push(`brokerGroupId: [${brokerGroupIds.join(',')}]`);
			}

			return {
				filters: joinFilters(filtersArray),
			};
		}

		const filtersArray = [
			...baseFilters,
			`pipeline := ${pipelineId}`,
			`dealStage := ${stageId}`,
			`status:!=${DEAL_STATUS_TYPES.archived}`,
		];

		// Prospect filter
		if (selectedIsProspect.length > 0) {
			filtersArray.push(`(${selectedIsProspect.join(' && ')})`);
		}

		// Date filters - validate before adding
		if (selectedCreateDate.length > 0) {
			const validDateFilters = selectedCreateDate.filter(
				(dateStr) => dateStr && dateStr.trim() !== '',
			);
			if (validDateFilters.length > 0) {
				filtersArray.push(`(${validDateFilters.join(' && ')})`);
			}
		}

		if (selectedEstimatedCloseDate.length > 0) {
			const validDateFilters = selectedEstimatedCloseDate.filter(
				(dateStr) => dateStr && dateStr.trim() !== '',
			);
			if (validDateFilters.length > 0) {
				filtersArray.push(`(${validDateFilters.join(' && ')})`);
			}
		}

		if (selectedRenewalDate.length > 0) {
			const validDateFilters = selectedRenewalDate.filter(
				(dateStr) => dateStr && dateStr.trim() !== '',
			);
			if (validDateFilters.length > 0) {
				filtersArray.push(`(${validDateFilters.join(' && ')})`);
			}
		}

		if (isDebtors && outstandingDaysSchema) {
			filtersArray.push(outstandingDaysSchema);
		}

		return {
			filters: joinFilters(filtersArray),
		};
	}, [
		isProspect,
		pipelineId,
		stageId,
		baseFilters,
		brokerGroupIds,
		selectedIsProspect,
		selectedCreateDate,
		selectedEstimatedCloseDate,
		selectedRenewalDate,
		isDebtors,
		outstandingDaysSchema,
	]);

	return filterSchema;
};
